import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f46ff1d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " ")

import { ComputedRef, computed, toRefs, withDefaults } from 'vue'

  import { TUnit } from '@/types/units'
  import { units, convertDistance } from '@/utils/units'

  interface Props {
    distance: number
    unitFrom: TUnit
    useImperialUnits: boolean
    digits?: number
    displayUnit?: boolean
    speed?: boolean
    strong?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    distance: null,
    unitFrom: null,
    useImperialUnits: { type: Boolean },
    digits: { default: 2 },
    displayUnit: { type: Boolean, default: true },
    speed: { type: Boolean, default: false },
    strong: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { distance: number, unitFrom: TUnit, useImperialUnits: boolean, digits: number, displayUnit: boolean, speed: boolean, strong: boolean }

  

  const {
    digits,
    displayUnit,
    distance,
    speed,
    strong,
    unitFrom,
    useImperialUnits,
  } = toRefs(props)
  const unitTo: ComputedRef<TUnit> = computed(() =>
    useImperialUnits.value
      ? units[unitFrom.value].defaultTarget
      : unitFrom.value
  )
  const convertedDistance = computed(() =>
    useImperialUnits.value
      ? convertDistance(
          distance.value,
          unitFrom.value,
          unitTo.value,
          digits.value
        )
      : parseFloat(distance.value.toFixed(digits.value))
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: _normalizeClass(["distance", { strong: _unref(strong) }])
    }, _toDisplayString(_unref(convertedDistance)), 3),
    _hoisted_1,
    (_unref(displayUnit))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["unit", { strong: _unref(strong) }])
        }, _toDisplayString(_unref(unitTo)) + _toDisplayString(_unref(speed) ? '/h' : ''), 3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})